import React from "react";
import Plan, { PlanTypeInstance } from "./Plan";
import { DesignersGrid } from "./DesignersGrid";
import { CatalogueLink } from "./CatalogueLink";

const Lite: React.FC<PlanTypeInstance> = ({ itemLimit, tiersAccessible, price, onClick }) => {
  return (
    <Plan name="Lite" itemLimit={itemLimit} tiersAccessible={tiersAccessible} price={price} onClick={onClick}>
      <div>
        Access to <CatalogueLink tiersAccessible={tiersAccessible}>Lite Styles</CatalogueLink>
      </div>
      <div>100+ Brands, 1,000+ Styles</div>
      <DesignersGrid>
        <img src={require("../../../../../assets/lite_plan_designer_1.png")} />
        <img src={require("../../../../../assets/lite_plan_designer_2.png")} />
        <img src={require("../../../../../assets/lite_plan_designer_3.png")} />
        <img src={require("../../../../../assets/lite_plan_designer_4.png")} />
        <img src={require("../../../../../assets/lite_plan_designer_5.png")} />
        <img src={require("../../../../../assets/lite_plan_designer_6.png")} />
      </DesignersGrid>
    </Plan>
  );
};

export default Lite;
